import { Provider } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Auth from "./layout/Auth";
import Main from "./layout/Main";
import routes from "./routes";
import store from "./store";
import { WalletProvider } from "./web3/WalletProvider";
import { ToastContainer } from "react-toastify";

function App() {
    return (
        <>
            <Provider store={store}>
                <WalletProvider>
                    <ToastContainer position="top-right" autoClose={4000} />
                    <BrowserRouter>
                        <Switch>
                            {routes.map((route) => {
                                switch (route.layout) {
                                    case "main":
                                        return (
                                            <Route exact path={route.path}>
                                                <Main>
                                                    <route.component />
                                                </Main>
                                            </Route>
                                        );
                                    case "auth":
                                        return (
                                            <Route exact path={route.path}>
                                                <Auth>
                                                    <route.component />
                                                </Auth>
                                            </Route>
                                        );
                                    default:
                                        return (
                                            <Route exact path={route.path}>
                                                <route.component />
                                            </Route>
                                        );
                                }
                            })}
                            <Redirect to="/" />
                        </Switch>
                    </BrowserRouter>
                </WalletProvider>
            </Provider>
        </>
    );
}

export default App;
